let offsetMs = 0;

/** Learns the server's clock from an HTTP `Date` header; an unreadable one is ignored. */
export function syncServerClock(dateHeader: unknown, receivedAtMs: number = Date.now()) {
  if (typeof dateHeader !== 'string') return;
  const serverMs = Date.parse(dateHeader);
  if (Number.isFinite(serverMs)) offsetMs = serverMs - receivedAtMs;
}

/** The server's current time in ms, or the browser's until a response has taught the offset. */
export function serverNowMs(): number {
  return Date.now() + offsetMs;
}
